import React, { memo, useMemo } from 'react';

import NonPayoutMetricsPanel from '../../../components/nonPayoutMetricsPanel/NonPayoutMetricsPanel';

interface PropTypes {
    empNum?: number;
    scorecardVersion?: number;
    monthlyMetricsData: any;
    monthlyMetricHistory: any;
    dailyMetricsData: any;
}

const AgentScoreCardDashboardNonPayout = memo(({
    empNum,
    scorecardVersion,
    monthlyMetricsData,
    monthlyMetricHistory,
    dailyMetricsData,
}: PropTypes) => {
    const metrics: any[] = useMemo(
        () => monthlyMetricsData?.data ?? [],
        [monthlyMetricsData]
    );

    return (
        <NonPayoutMetricsPanel
            metrics={metrics}
            dailyMetricsData={dailyMetricsData}
            monthlyMetricHistory={monthlyMetricHistory}
            scorecardVersionId={scorecardVersion ?? 0}
            employeeNumber={empNum?.toString() ?? ''}
        />
    );
});

AgentScoreCardDashboardNonPayout.displayName = 'AgentScoreCardDashboardNonPayout';

export default AgentScoreCardDashboardNonPayout;
